import { render } from "./AllowanceModal.vue?vue&type=template&id=6a25d3b4"
import script from "./AllowanceModal.vue?vue&type=script&lang=js"
export * from "./AllowanceModal.vue?vue&type=script&lang=js"

import "./AllowanceModal.vue?vue&type=style&index=0&id=6a25d3b4&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__